"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Assignable = void 0;
var Assignable = /** @class */function () {
  function Assignable(properties, allowed) {
    var instance = this;
    properties = Object.assign({}, this.defaultProperties, properties);
    if (!allowed) {
      allowed = Object.keys(properties);
    }
    allowed.map(function (key) {
      instance[key] = properties[key];
    });
  }
  Object.defineProperty(Assignable.prototype, "defaultProperties", {
    get: function () {
      return {};
    },
    enumerable: false,
    configurable: true
  });
  Assignable.prototype.formatDates = function (dateFields) {
    var instance = this;
    dateFields.forEach(function (p) {
      if (p in instance && instance[p]) {
        instance[p] = new Date(instance[p]);
      }
    });
  };
  return Assignable;
}();
exports.Assignable = Assignable;
